import type { PreferenceStoreIdentifier } from '@main/cm-types';
import type { EnrichedIdentifiers } from '@main/sombra-types';

/**
 * Converts preference store identifiers to enriched identifiers for diffie-hellman preference upsert.
 *
 * Groups the identifiers by their names
 *
 * @param identifiers - The identifiers present on the consent record.
 * @param identifiersToExclude - The identifier values to exclude from the enrichment.
 * @returns The enriched Identifiers
 */
export function convertPSIdentifiersToEnrichedIdentifiers(
  identifiers: PreferenceStoreIdentifier[],
  identifiersToExclude: string[] = [],
): EnrichedIdentifiers | undefined {
  if (identifiers.length > 0) {
    return identifiers.reduce((acc, { value, name }) => {
      acc[name] ||= [];
      if (!identifiersToExclude.includes(value)) {
        acc[name].push({ value });
      }
      return acc;
    }, {} as EnrichedIdentifiers);
  }
  return undefined;
}
